<template>
  <div class="global-tip">
    <div class="container">
      <div class="content">{{ content }}</div>
      <div class="global-tip-button" @click="click">{{ confirmText }}</div>
    </div>
  </div>
</template>

<script>
export default _extend({
  name: 'GlobalTip',
  props: {
    content: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    }
  },
  methods: {
    click() {
      this.$emit('confirm');
    }
  }
});
</script>

<style lang="scss" scoped>
@import './GlobalTip.scss';
</style>



// WEBPACK FOOTER //
// src/components/GlobalTip/GlobalTip.vue